<template>
  <div>
    <h1>{{ tableTitle }}</h1>
    <general-table
      ref="generalTableAudit"
      :api-url="apiUrl"
      :delete-content="true"
      :block-content="false"
      :edit-content="false"
      :view-content="false"
      :have-search="false"
      :filter-audit="true"
      :columns="columns"
      :type="'page'"
      :top-header="topHeader"
    >
      <template #cell(request_engineers)="data">
        <ul class="list-unstyled">
          <li
            v-for="item in data.item.request.assigned_engineers"
            :key="item.id"
            class="d-flex flex-column align-items-start"
          >
            <div>
              <strong> Name :</strong> <span> {{ item.user.name }}</span>
            </div>
            <div>
              <strong> Job :</strong> <span> {{ item.job }}</span>
            </div>
            <div>
              <strong> Type :</strong> <span> {{ item.type }}</span>
            </div>
            <div class="w-100 text-left">
              <strong> Email :</strong> <span> {{ item.user.email }}</span>
              <hr>
            </div>
          </li>
        </ul>
      </template>

      <template #cell(request_certificate)="data">
        <ul class="list-unstyled">
          <li>
            {{ data.item.request.certificate.name.ar }}
          </li>
          <li>
            {{ data.item.request.certificate.name.en }}
          </li>
        </ul>
      </template>
      <template #cell(request_sub_certificate)="data">
        <ul class="list-unstyled">
          <li>
            {{ data.item.request.certificate_name.ar }}
          </li>
          <li>
            {{ data.item.request.certificate_name.en }}
          </li>
        </ul>
      </template>
      <template #cell(return_to_ce)="data">
        <span>
          <feather-icon
            icon="RotateCcwIcon"
            class="cursor-pointer"
            @click="returnToCE(data.item.id, data.item.request.request_code)"
          />
        </span>
      </template>
      <template #cell(assign_date_engineer)="data">
        <span v-if="data.item.status === 'pending'">
          <feather-icon
            icon="Edit3Icon"
            class="cursor-pointer"
            @click="$router.push({ name: 'assign-date-and-eng', params: { id: data.item.id } })"
          />
        </span>
      </template>
      <template #cell(attachments_audit)="data">
        <span
          v-for="(file , index) in data.item.attachments"
          :key="index"
          class="d-flex align-center justify-content-center"
        >
          <a
            :href="file.url"
            target="_blank"
          >
            <feather-icon
              icon="FileIcon"
              size="25"
              class="cursor-pointer ml-1"
              color="black"
            />
          </a>
        </span>
      </template>

    </general-table>
  </div>
</template>

<script>
import axios from 'axios'
import GeneralTable from '@/components/general-table/GeneralTable.vue'

export default {

  components: { GeneralTable },
  props: {
    tableTitle: {
      type: String,
      default: () => '',
    },
    apiUrlProps: {
      type: String,
      default: () => '',
    },
    columns: {
      type: Array,
      default: () => [],
    },
    topHeader: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      filter: {},
      loading: false,
    }
  },

  computed: {
    apiUrl() {
      let base = `${this.apiUrlProps}?`

      if (!Object.values(this.filter).length) {
        return base.slice(0, -1)
      }

      // eslint-disable-next-line no-restricted-syntax
      for (const [key, value] of Object.entries(this.filter)) {
        if (key && value) {
          base += `${key}=${value}&`
        }
      }
      // console.log(base.slice(0, -1))
      return base.slice(0, -1)
    },
  },
  methods: {
    returnToCE(id, requestId) {
      this.$swal({
        title: `Are you sure you want to return this request (${requestId}) to the CE?`,
        input: 'text',
        inputPlaceholder: 'Enter your comments for return...',
        showCancelButton: true,
        confirmButtonText: 'Submit',
        cancelButtonText: 'Cancel',
        preConfirm: comment => {
          this.loading = true
          this.$swal.showLoading()

          return axios.post(`/audit/return-to-ce/${id}`, {
            comment: comment || '',
          })
            .then(() => {
              this.$swal.close()
              this.$swal('Return!', 'Return Successfully.', 'success')
              this.$refs.generalTableAudit.getAllData(1)
            })
            .catch(() => {
              this.$swal.close()
              this.$swal('Error!', 'There was an issue with return.', 'error')
            })
            .finally(() => {
              this.loading = false
            })
        },
      })
    },

  },
}
</script>
